import "./ButtonServ.css";

export default function ButtonServ({
  children,
  variant = "primary",
  icon = null,
  pulse = false,
}) {
  const getButtonClass = () => {
    let className = "buttonServ";

    if (variant) {
      className += ` buttonServ-${variant}`;
    }

    if (pulse) {
      className += " buttonServ-pulse";
    }

    if (icon) {
      className += " buttonServ-withIcon";
    }

    return className;
  };

  const renderIcon = () => {
    switch (icon) {
      case "calendar":
        return <span className="buttonServ-icon">📅</span>;
      case "arrow":
        return <span className="buttonServ-icon">→</span>;
      case "sparkle":
        return <span className="buttonServ-icon">✨</span>;
      case "star":
        return <span className="buttonServ-icon">⭐</span>;
      case "heart":
        return <span className="buttonServ-icon">❤️</span>;
      default:
        return null;
    }
  };

  return (
    <button className={getButtonClass()}>
      {icon && renderIcon()}
      <span className="buttonServ-text">{children}</span>
    </button>
  );
}
